var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"border":"left","type":_vm.type,"dismissible":_vm.dismissible},on:{"input":_vm.onInput}},[_vm._v("\n"+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }